import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "reactstrap";
import "./style.css";
import noavatar from "../../../assets/img/noavatar.png";
import Pagination from "../../pagination";

function Product(data) {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.data.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div>
        {currentData?.map((item) => {
          return (
            <>
              <Button
                key={item.id}
                className={`card_product ${
                  item.quantity === 0 ? "card_product_none" : ""
                }`}
                onClick={() => navigate(`/product/${item.id}`)}
              >
                {item.quantity === 0 ? (
                  <div className="sold_out">
                    <div className="text_sold">
                      <span className="t-white fs-18">
                        Sold <br /> out
                      </span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div
                  className="percent_sale t-white py-1 px-2"
                  style={{
                    display: `${item.discount !== 0 ? "block" : "none"}`,
                  }}
                >
                  {item.discount} &#37;
                </div>

                <div className="img_product">
                  <img
                    src={
                      `${process.env.REACT_APP_URL_IMAGE + item.image}` ||
                      noavatar
                    }
                    alt="product"
                    width="100%"
                    height="100%"
                  />
                </div>

                <div className="py-2 company_name">
                  <p className="name_brand text-start fs-6 fw-bold">
                    {item.category.name}
                  </p>
                  <p className="name_product fs-6 text-start ">{item.name}</p>
                </div>

                <div className="price pt-2 d-flex align-items-center justify-content-between">
                  <p className="price_cost fw-bold t-primary">
                    {(
                      (item.price * (100 - item.discount)) /
                      100
                    ).toLocaleString("vi")}
                    &#273;
                  </p>
                  <p className="price_sale fw-bold">
                    {item.price.toLocaleString("vi")}&#273;
                  </p>
                </div>
              </Button>
            </>
          );
        })}
      </div>

      <Pagination
          paginate={paginate}
          postsPerPage={dataPerPage}
          totalPosts={data.data.length}
        />
    </>
  );
}

export default Product;
